import { ConfigType } from './../../model/learn-cert/default-learn-cert-config/config-type.enum';
import { DefaultLearnCertConfigDTO } from '../../model/learn-cert/default-learn-cert-config/default-learn-cert-config-dto';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isUndefined } from 'util';
import { JsonUtil } from '../util/json.util';
import { map } from 'rxjs/operators';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';

@Injectable()
export class NecDefaultLearnCertConfigInterface {
  private url = NecUrl.SERVER_URL + '/mgt/defaultLearnCertConfigs';

  constructor(private http: HttpClient) {
  }

  queryDefaultConfigsByDeptId(deptId: number, type?: ConfigType): Observable<DefaultLearnCertConfigDTO> {
    type = isUndefined(type) ? ConfigType.STUDENT : type;
    const params = new HttpParams().set('deptId', deptId.toString()).set('type', type.toString());
    return this.http.get<DefaultLearnCertConfigDTO>(this.url, { params })
      .pipe(map((config: DefaultLearnCertConfigDTO) => {
        return JsonUtil.jsonConvert(config, DefaultLearnCertConfigDTO);
      }));
  }

  queryDefaultConfigsByGroupId(groupId: number, type?: ConfigType): Observable<DefaultLearnCertConfigDTO> {
    type = isUndefined(type) ? ConfigType.STUDENT : type;
    const params = new HttpParams().set('deptId', groupId.toString()).set('type', type.toString());
    return this.http.get<DefaultLearnCertConfigDTO>(this.url, { params })
      .pipe(map((config: DefaultLearnCertConfigDTO) => {
        return JsonUtil.jsonConvert(config, DefaultLearnCertConfigDTO);
      }));
  }
}
